import React from "react";
import TaskRow from "./TaskRow";
import { TaskList as List, Message } from "./design";

const TaskList = ({ tasks, loading, error, busy, onPreview, onStatusChange, onDelete }) => (
    <>
        {loading && <Message>Aufgaben werden geladen...</Message>}
        {error && <Message role="alert">Fehler: {error}</Message>}
        {!loading && !error && (
            <List>
                {tasks.map(task => (
                    <TaskRow
                        key={task.id}
                        task={task}
                        busy={busy}
                        onPreview={onPreview}
                        onStatusChange={onStatusChange}
                        onDelete={onDelete}
                    />
                ))}
                {tasks.length === 0 && <Message>Keine Aufgaben vorhanden.</Message>}
            </List>
        )}
    </>
);
export default TaskList;
